import { render, staticRenderFns } from "./SelectedListView.vue?vue&type=template&id=a231f892&"
import script from "./SelectedListView.vue?vue&type=script&lang=js&"
export * from "./SelectedListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports